import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Menu from 'controls/menu/Menu';
import Toolbar from 'components/track-params/toolbar/Toolbar';
import CycloParams from 'controls/cyclo-params/CycloParams';

const CYCLO_CONTEXT = 'trackParams';

class TrackParams extends React.Component {
  render () {
    return (
      <div>
        <Menu/>
        <Toolbar trackId={ this.props.trackId }/>
        <CycloParams
          trackId={ this.props.trackId }
          context={ CYCLO_CONTEXT }
          chosenAnalogParams={ this.props.recorderCyclo.chosenAnalogParams }
          chosenBinaryParams={ this.props.recorderCyclo.chosenBinaryParams }
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    trackId: ownProps.match.params.id,
    recorderCyclo: state.recorderCyclo
  };
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackParams);
